<template>
  <div class="input-group__disclosure-button-wrapper">
    <button
      aria-controls="password"
      aria-expanded="false"
      v-if="hide"
      type="button"
      class="input-group__reveal-button"
      @click="showAction"
    >
      <ShowPasswordIcon
        class="icon layout--margin-right-xxs"
        style="width: 26px; height: 14px;"
      />Show
    </button>
    <button
      aria-controls="password"
      aria-expanded="true"
      v-if="!hide"
      type="button"
      class="input-group__reveal-button"
      @click="hideAction"
    >
      <HidePasswordIcon
        class="icon"
        style="width: 26px; height: 14px; margin-right: 11px;"
      />Hide
    </button>
  </div>
</template>

<script>
import ShowPasswordIcon from "../assets/icons/iconShowPassword.svg";
import HidePasswordIcon from "../assets/icons/iconHidePassword.svg";

export default {
  name: "disclosure-button",
  props: {
    hide: Boolean,
    target: String,
    hideAction: Function,
    showAction: Function,
  },
  components: {
    ShowPasswordIcon,
    HidePasswordIcon,
  },
};
</script>

<style></style>
